<template>
  <p>When submitting videos, please follow these guidelines:</p>
  <ul>
    <li>Must be in GP/3G2, ASF, AVI, DV, FLV, MOV, MP4/F4V, MPEG/MPG, QT, or WMV format.</li>
    <li>File size must be 50 MB or less.</li>
    <li>If you are not the copyright holder, you may not submit copyrighted videos.</li>
    <li>Objectionable videos will be rejected.</li>
    <li>Uploaded videos become the property of {{ isMcom ? "Macy's" : "Bloomingdale's" }}.</li>
  </ul>
</template>

<script setup>
import { useBrand } from '~/composables/useBrand';

const { isMcom } = useBrand();
</script>
